export const shumaType = {
  REGULAR: 1,
  BANK_CODE_19: 2,
  BANK_FULL: 3,
  BANK_SHORT: 4,
};

const notRegularSteps = [
  shumaType.BANK_CODE_19,
  shumaType.BANK_FULL,
  shumaType.BANK_SHORT,
];

export const isBankShumaTypeID = shumaTypeID => {
  return notRegularSteps.includes(shumaTypeID);
};

/**
 * for now there are 4 shuma types:
 * 1 regular - the steps we have now
 * 2 bank code 19
 * 3 bank full
 * 4 bank short
 */
